module.exports = __webpack_public_path__ + "img/cjsl.3cee2e9b.png";